import { render, staticRenderFns } from "./TopUpRequestDashboard.vue?vue&type=template&id=49fb27c8&"
import script from "./TopUpRequestDashboard.vue?vue&type=script&lang=js&"
export * from "./TopUpRequestDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports